import Vue from 'vue'
import App from './App.vue'
import {library} from '@fortawesome/fontawesome-svg-core'
import {
    faCog,
    faCaretRight,
    faCaretLeft,
    faExpand,
    faAngleRight,
    faTrophy,
    faClone,
    faUser,
    faCheck,
    faTimes,
    faCamera,
    faTrashAlt,
    faArrowsAltH,
    faTheaterMasks,
    faArrowLeft,
    faQrcode,
    faExchangeAlt,
    faFlagCheckered,
    faSignOutAlt,
    faPlus,
    faSave,
    faShare,
    faShareAlt,
    faShareSquare,
    faShareAltSquare,
    faDiceD20
} from '@fortawesome/free-solid-svg-icons'

library.add(
    faCog,
    faAngleRight,
    faTrophy,
    faClone,
    faUser,
    faCheck,
    faTimes,
    faExpand,
    faCamera,
    faTrashAlt,
    faCaretRight,
    faCaretLeft,
    faArrowsAltH,
    faTheaterMasks,
    faArrowLeft,
    faQrcode,
    faExchangeAlt,
    faFlagCheckered,
    faSignOutAlt,
    faPlus,
    faSave,
    faShareSquare,
    faDiceD20
)

import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome'
import VueLazyLoad from 'vue-lazyload'
import Vue2TouchEvents from 'vue2-touch-events'

Vue.use(Vue2TouchEvents, {
    disableClick: false,
    touchClass: '',
    tapTolerance: 10,
    swipeTolerance: 150,
    touchHoldTolerance: 300,
    // swipeTolerance: 30,
    // longTapTimeInterval: 400
})
Vue.use(VueLazyLoad)

Vue.config.productionTip = false;
Vue.component('font-awesome-icon', FontAwesomeIcon);

import VueQrcodeReader from "vue-qrcode-reader";

Vue.use(VueQrcodeReader);

// import VueMobileDetection from 'vue-mobile-detection'
// Vue.use(VueMobileDetection)


import router from './router';
import {store} from "@/store/store";

new Vue({
    router,
    render: h => h(App),
    store,
}).$mount('#app')
